/**
 * Status of the trade aggregation request.
 * tag: 2790
 * @readonly
 * @enum {number} (int)
 */
export enum TradeAggregationRequestStatus {
  /** Accepted */
  Accepted = 0,
  /** Rejected */
  Rejected = 1,
}
